import { Box, CircularProgress, Modal, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useThemePalette } from "common/hooks/theme_palette";
import DetailsUse from "components/Atoms/SharedComponents/CRUD/details-use";
import FormHeader from "components/Molecules/Products/Variants/formHeader";
import { detailsData } from "templates/products/productVariant/details";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: 650 },
  height: { xs: "95vh", md: 900 },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "8px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export default function VariantDetails({
  open,
  setOpen,
  details,
  optionTypesFilter,
  load,
}) {
  const { t } = useTranslation();
  const { oliveGreen } = useThemePalette();
  const handleClose = () => {
    setOpen(false);
  };

  const data = {
    pageTitle: "",
    editBtn: false,
    deleteBtn: false,
    data: {
      list: detailsData({ data: { ...details, optionTypesFilter }, t }),
      images: details?.media?.map((image) => {
        return {
          img: image?.url,
        };
      }),
    },
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <FormHeader
          handleClose={handleClose}
          title={t("products.breadcrumb_variant_details")}
        />
        <Stack sx={{ overflowY: "auto", flexGrow: 1, p: 2 }}>
          {load?.loading && load?.type == "variantsDetails" ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}
            >
              <CircularProgress sx={{ color: oliveGreen }} />
            </Box>
          ) : (
            <DetailsUse data={data} />
          )}
        </Stack>
      </Box>
    </Modal>
  );
}
